import { render } from "./MarketingPreferencesModal.vue?vue&type=template&id=173f4996&scoped=true"
import script from "./MarketingPreferencesModal.vue?vue&type=script&lang=js"
export * from "./MarketingPreferencesModal.vue?vue&type=script&lang=js"

import "./MarketingPreferencesModal.vue?vue&type=style&index=0&id=173f4996&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173f4996"]])

export default __exports__